import React from 'react';
import ReactMarkdown from 'react-markdown';

const POKKET_LOGO_URL = 'https://db.pokketcoach.com/storage/v1/object/public/pokket-icons//pokket_waving.svg';

const ChatMessage = ({ text, sender, isHistoric = false, userDetails = {} }) => {
  const isUser = sender === 'user';

  // Default logo fallback for development
  const logoFallback = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Ccircle cx='12' cy='12' r='10' fill='%23C0E1F7' stroke='%230A84FF' stroke-width='2'/%3E%3Cpath d='M8 8 Q12 6, 16 8 Q18 12, 16 16 Q12 18, 8 16 Q6 12, 8 8' fill='%230A84FF'/%3E%3Ccircle cx='9' cy='10' r='1.5' fill='white'/%3E%3Ccircle cx='15' cy='10' r='1.5' fill='white'/%3E%3C/svg%3E";
  
  // Get the first letter for the user avatar
  const getUserInitial = () => {
    // Use preferred name if available
    if (userDetails?.preferredName) {
      return userDetails.preferredName.charAt(0).toUpperCase();
    }
    
    // Fall back to first name if available
    if (userDetails?.firstName) {
      return userDetails.firstName.charAt(0).toUpperCase();
    }
    
    // Default fallback
    return 'U';
  };

  return (
    <div className={`px-4 py-2 flex ${isUser ? 'justify-end' : 'justify-start'} ${isHistoric ? 'opacity-75' : ''}`}>
      {/* Avatar for bot messages */}
      {!isUser && (
        <div className="mr-2 flex-shrink-0 flex items-center">
          <img 
            src={POKKET_LOGO_URL} 
            alt="Pokket" 
            className={`rounded-full chat-message-pokket-logo ${isHistoric ? 'opacity-75' : ''}`}
            style={{
              minWidth: '80px',
              minHeight: '80px',
              maxWidth: '200px',
              maxHeight: '200px'
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = logoFallback;
            }}
          />
        </div>
      )}
      
      {/* Message Bubble */}
      <div 
        className={`max-w-[75%] rounded-lg px-4 py-2 ${
          isUser ? 'text-white' : 'text-gray-800'
        } ${isHistoric ? 'opacity-75' : ''}`}
        style={{
          backgroundColor: isUser 
            ? (isHistoric ? '#599BC2' : '#0071AF') 
            : (isHistoric ? '#D9EBF7' : '#C0E1F7')
        }}
      >
        <div className="text-lg font-light break-words">
          <ReactMarkdown>{text}</ReactMarkdown>
        </div>
      </div>
      
      {isUser && (
        <div className="ml-2 flex-shrink-0 flex items-center">
          <div 
            className={`w-10 h-10 rounded-full flex items-center justify-center text-white ${isHistoric ? 'opacity-75' : ''}`}
            style={{
              backgroundColor: isHistoric ? '#599BC2' : '#0071AF'
            }}
          >
            {/* Display first letter of preferred name or first name */}
            <span className="text-lg font-semibold">{getUserInitial()}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatMessage; 